export enum ReportTypeRequest {
    GroundConversationReport = 'GroundConversationReport',
}
